import {ReactElement, ReactNode} from 'react'
import {Typography, Grid} from '@material-ui/core'
import {useStyles} from './styles'

type Item = {
  id: string
  caption: ReactNode
  value: ReactNode
}

type GridSectionProps = {
  title: ReactNode
  items: Item[]
}

export const GridSection = (props: GridSectionProps): ReactElement => {
  const {title, items} = props

  const classes = useStyles()

  return (
    <Grid item container xs={12} className={classes.container}>
      <Grid item md={8} xs={6} className={classes.title}>
        <Typography variant="h4">
          {title}
        </Typography>
      </Grid>
      <Grid item container xs={12} className={classes.items} direction='row' justifyContent='space-between' alignItems='center'>
        {items.map((item) => (
          <Grid key={item.id} item className={classes.item} xs={6} sm="auto">
            <Typography variant='caption'>
              {item.caption}
            </Typography>
            <Typography variant='body1' className={classes.value}>
              {item.value}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}
